import React from 'react';
import { cn } from '@/app/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  const hasBgClass = typeof className === 'string' && /\bbg-[^\s]+/.test(className);
  const hasRoundedClass = typeof className === 'string' && /\brounded(?:-[^\s]+)?/.test(className);
  return (
    <div
      className={cn(
        'animate-pulse',
        hasRoundedClass ? undefined : 'rounded-md',
        hasBgClass ? undefined : 'bg-surface_gray_200',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
